import {
  ChannelAvatar,
  CircleCheckBigIcon,
  Flex,
  Heading,
  Text,
} from '@buffer-mono/popcorn'

import type { PostingGoalChannel } from '../usePostingGoalsSummary'

import styles from './PostingGoalsHoverCard.module.css'

import type { JSX } from 'react'

function channelLabel(channel: PostingGoalChannel['channel']): string {
  return channel.displayName ?? channel.name
}

/**
 * Per-channel breakdown of posting goal progress shown in the Posting Goals
 * scorecard hover card, so an unmet goal is identifiable at a glance.
 */
export function PostingGoalsHoverCard({
  goals,
}: {
  goals: PostingGoalChannel[]
}): JSX.Element {
  return (
    <Flex direction="column" gap="xs" className={styles.container}>
      <Heading as="h2" size="xs">
        Posting goals
      </Heading>
      <Text size="sm" color="subtle">
        Your goal progress across connected channels this week.
      </Text>
      {goals.length === 0 ? (
        <Text size="sm" color="subtle">
          No posting goals set yet.
        </Text>
      ) : (
        <Flex
          as="ul"
          direction="column"
          gap="xs"
          fullWidth
          className={styles.list}
        >
          {goals.map(({ channel, postingGoal }) => {
            const met = postingGoal.status === 'Hit'
            return (
              <Flex as="li" key={channel.id} align="center" gap="sm" fullWidth>
                <ChannelAvatar
                  channel={channel.service}
                  src={channel.avatar}
                  size="xsmall"
                  alt=""
                />
                <Text size="sm" className={styles.name} translate="no">
                  {channelLabel(channel)}
                </Text>
                {met ? (
                  <Flex as="span" align="center" gap="3xs">
                    <CircleCheckBigIcon color="success" size="xsmall" />
                    <Text size="sm" color="success">
                      Met
                    </Text>
                  </Flex>
                ) : (
                  <Text size="sm" color="subtle">
                    {postingGoal.sentCount} of {postingGoal.goal} posts
                  </Text>
                )}
              </Flex>
            )
          })}
        </Flex>
      )}
    </Flex>
  )
}
